module.exports = __webpack_public_path__ + "img/CM-JN-24-Chevy-Established.ef9f7134.jpg";